import { noop } from 'lodash';
import { createContext, useContext } from 'react';
import {
  DATE_RANGE_OPTIONS,
  type DateInput,
  type SubmitAsOption,
} from '../types';

type FactsAndFiguresContext = {
  agentOptions: SubmitAsOption[];
  agents: SubmitAsOption[];
  dateRange: DATE_RANGE_OPTIONS;
  endDate: DateInput;
  filtersCount: number;
  isLoadingAgents: boolean;
  isMobile: boolean;
  isModalOpen: boolean;
  onChangeAgents: (agents: SubmitAsOption[]) => void;
  onChangeDateRange: (dateRange: DATE_RANGE_OPTIONS) => void;
  onChangeEndDate: (date: DateInput) => void;
  onChangeStartDate: (date: DateInput) => void;
  onClearAgents: () => void;
  onDeleteAgent: (agent: SubmitAsOption) => void;
  onReset: () => void;
  startDate: DateInput;
  toggleModal: () => void;
};

export const FACTS_AND_FIGURES_CONTEXT_DEFAULTS = {
  agentOptions: [],
  agents: [],
  dateRange: DATE_RANGE_OPTIONS.DEFAULT,
  endDate: null,
  filtersCount: 0,
  isLoadingAgents: false,
  isMobile: false,
  isModalOpen: false,
  onChangeAgents: noop,
  onChangeDateRange: noop,
  onChangeEndDate: noop,
  onChangeStartDate: noop,
  onClearAgents: noop,
  onDeleteAgent: noop,
  onReset: noop,
  startDate: null,
  toggleModal: noop,
};

export const FactsAndFiguresContext = createContext<FactsAndFiguresContext>(
  FACTS_AND_FIGURES_CONTEXT_DEFAULTS,
);

export function useFactsAndFiguresContext() {
  return useContext(FactsAndFiguresContext);
}
